const firebaseConfig = {
  apiKey: "AIzaSyBkQ6PHfTtKganYoV_o_E9mPMWx8p0d1EE",
  authDomain: "code-interview-task.firebaseapp.com",
  databaseURL: "https://code-interview-task.firebaseio.com",
  projectId: "code-interview-task",
  storageBucket: "code-interview-task.appspot.com",
  messagingSenderId: "979549446892",
  appId: "1:979549446892:web:3d857ac4de2493444bbbc9",
  measurementId: "G-W0XM4T0GZQ",
};

export default firebaseConfig;

export const clientID = "W_v2CXGoc8MYdNK1h1fuuznfkwAZOFnziATzZrLv67U";
